import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router";
import { UTAH_PROGRAM_ID } from "~/participant/constants/utah.constants";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export async function onboardingLoader(queryClient: QueryClient) {
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  if (user?.codeOfConduct) {
    return redirect("/");
  }

  if (user?.profile?.programs?.some((program) => program.id === UTAH_PROGRAM_ID)) {
    return redirect("/onboarding/utah");
  }

  return null;
}
